import type {TaxonomyType} from "./../graphql/misc";
import type {RegionsCollectionItem, EstatesCollectionItem, SuburbsCollectionItem, StatusesCollectionItem, HouseLengthsCollectionItem} from "@nuxt/content";

const useEstates = async (): Promise<TaxonomyType[] | EstatesCollectionItem[]> => {
  return await queryCollection('estates').all();
}
const useRegions = async (): Promise<TaxonomyType[] | RegionsCollectionItem[]> => {
  return await queryCollection('regions').all();
}

const useSuburbs = async (): Promise<TaxonomyType[] | SuburbsCollectionItem[]> => {
  return await queryCollection('suburbs').all();
}

const useStatuses = async (): Promise<TaxonomyType[] | StatusesCollectionItem[]> => {
  return await queryCollection('statuses').all();
}

const useHouseLengths = async (): Promise<TaxonomyType[] | HouseLengthsCollectionItem[]> => {
  return await queryCollection('houseLengths').all();
}

export {
  useEstates,
  useRegions,
  useSuburbs,
  useStatuses,
  useHouseLengths
}
